import React from "react";
import "./Tournament.css";
import Header from "./Header";
import UpdateTournamentForm from "./UpdateTournamentForm";

export default function UpdateTournament() {
  return (
    <>
      <Header link={"tournament"} />
      <UpdateTournamentForm />
    </>
  );
}
